import { Box, Text } from '@wix/design-system';
import { Check } from '@wix/wix-ui-icons-common';
import React from 'react';
export const FeaturesNamespace = _ref => {
  var _namespace$content, _namespace$features;
  let {
    namespace,
    productId,
    t,
    Trans
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    marginBottom: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, t(((_namespace$content = namespace.content) == null || (_namespace$content = _namespace$content.name) == null ? void 0 : _namespace$content.translationKey) ?? '')), /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "SP1"
  }, (_namespace$features = namespace.features) == null ? void 0 : _namespace$features.filter(feature => {
    var _feature$values;
    return (_feature$values = feature.values) == null || (_feature$values = _feature$values[productId]) == null ? void 0 : _feature$values.available;
  }).map(feature => {
    var _feature$content;
    return /*#__PURE__*/React.createElement(Box, {
      key: feature.id,
      verticalAlign: "middle",
      gap: "SP1"
    }, /*#__PURE__*/React.createElement(Check, null), /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: ((_feature$content = feature.content) == null || (_feature$content = _feature$content.name) == null ? void 0 : _feature$content.translationKey) ?? '',
      components: {
        ellipsis: /*#__PURE__*/React.createElement(React.Fragment, null)
      },
      values: {
        domainName: undefined
      }
    })));
  })));
};
//# sourceMappingURL=FeaturesNamespace.js.map